(function () {
  "use strict";

  function d(sides) {
    return Math.floor(Math.random() * sides) + 1;
  }

  function pickOne(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }

  function pickX(arr, num) {
    if (!Array.isArray(arr)) return [];
    if (arr.length <= num) return arr.slice();
    var picked = [];
    var results = [];
    var randomIndex;
    for (var i = 0; i < num; i++) {
      randomIndex = Math.floor(Math.random() * arr.length);
      while (picked.indexOf(randomIndex) >= 0) {
        randomIndex = Math.floor(Math.random() * arr.length);
      }
      results.push(arr[randomIndex]);
      picked.push(randomIndex);
    }
    return results;
  }

  function toProperCase(str) {
    return String(str).replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

  function capitalizeAndDot(str) {
    var s = String(str);
    return s.substring(0, 1).toUpperCase() + s.substring(1) + ".";
  }

  function replaceAllToken(string, token, list) {
    var out = String(string);
    while (out.indexOf(token) > -1) {
      out = out.replace(token, pickOne(list));
    }
    return out;
  }

  function replacePlaceholders(string, isMale, data) {
    if (!string) return string;
    var out = String(string);
    var replacements = data.replacement_values || [];

    function isArrayReference(val) {
      return typeof val === "string" && val.substring(0, 5) === "$this";
    }

    replacements.forEach(function (replacement) {
      var replWith = replacement.replace_with;
      if (Array.isArray(replWith)) {
        out = replaceAllToken(out, replacement.value, replWith);
      } else if (typeof replWith === "string") {
        if (isArrayReference(replWith)) {
          var path = replWith.substring(6).split(".");
          var ref = data;
          for (var i = 0; i < path.length; i++) {
            if (!ref) break;
            ref = ref[path[i]];
          }
          if (ref) out = replaceAllToken(out, replacement.value, ref);
        }
      } else if (typeof replWith === "object") {
        if (isMale != null && replWith.male && replWith.female) {
          var replacementArr = isMale ? replWith.male : replWith.female;
          if (replacementArr[0] && isArrayReference(replacementArr[0])) {
            var refPath = replacementArr[0].split(".")[1];
            replacementArr = data[refPath];
          }
          out = replaceAllToken(out, replacement.value, replacementArr);
        }
      }
    });

    return out;
  }

  function gaussRandom() {
    var u = 2 * Math.random() - 1;
    var v = 2 * Math.random() - 1;
    var r = u * u + v * v;
    if (r === 0 || r >= 1) return gaussRandom();
    var c = Math.sqrt(-2 * Math.log(r) / r);
    return u * c;
  }

  function getNormallyDistributedNum(mean, stdDev) {
    return mean + gaussRandom() * stdDev;
  }

  function convertAmountToHighestCurrency(amount, coin, currencies) {
    var coins = currencies.coins || [];
    var conversions = currencies.conversions || [];
    var currentCurrencyIndex = coins.indexOf(coin);
    if (currentCurrencyIndex < 0) return amount + " " + coin;

    if (amount > conversions[currentCurrencyIndex] && currentCurrencyIndex !== coins.length - 1) {
      var priceNextCurrency = Math.ceil(amount / conversions[currentCurrencyIndex]);
      var remainder = amount % conversions[currentCurrencyIndex];
      return priceNextCurrency + " " + coins[currentCurrencyIndex + 1] +
        (remainder === 0 ? "" : " and " + remainder + " " + coin);
    } else if (amount < conversions[currentCurrencyIndex] && currentCurrencyIndex !== 0) {
      var pricePrevCurrency = amount * conversions[currentCurrencyIndex - 1];
      return Math.floor(pricePrevCurrency) + " " + coins[currentCurrencyIndex - 1];
    }
    return (amount < 1 ? Math.ceil(amount) : amount) + " " + coin;
  }

  function generateNPC(data, gender, nameSet, creatureType, descType) {
    var genderHeShe = "he";
    var genderManWoman = "man";
    var subset;

    if (gender === "any") gender = Math.random() > 0.5 ? "male" : "female";
    if (gender === "male") {
      subset = nameSet.male;
      genderHeShe = "he";
      genderManWoman = "man";
    } else {
      subset = nameSet.female;
      genderHeShe = "she";
      genderManWoman = "woman";
    }

    var npcValues = {};
    npcValues.firstname = pickOne(subset || []);
    npcValues.lastname = pickOne(nameSet.lastnames || []);

    var creatureSet = data.generated_creatures[creatureType];
    var randomIndex = Math.ceil(Math.random() * 100);
    var likely = 65;
    var midlikely = 93;
    var selectedProfessionSet;

    if (randomIndex < likely) {
      selectedProfessionSet = creatureSet.professions.common;
    } else if (randomIndex < midlikely) {
      selectedProfessionSet = creatureSet.professions.uncommon;
    } else {
      selectedProfessionSet = creatureSet.professions.rare;
    }

    var joblessString = "";
    var connectionString;
    if (creatureType === "humanoid") {
      var jobless = Math.random() * 100;
      if (jobless > 98) joblessString = "Unemployed ";
      connectionString = ", and ";
    } else {
      connectionString = ". " + genderHeShe.charAt(0).toUpperCase() + genderHeShe.slice(1) + " ";
    }

    npcValues.profession = joblessString + pickOne(selectedProfessionSet || []);

    if (creatureSet.population_data) {
      var popData = creatureSet.population_data;
      var age = getNormallyDistributedNum(popData.mean, popData.STD);
      if (popData.min && age < popData.min) age = popData.min;
      npcValues.age = Math.round(age);
    }

    npcValues.description = " " + pickOne(creatureSet.traits || []) + ". " +
      genderHeShe.charAt(0).toUpperCase() + genderHeShe.slice(1) + " has a " +
      pickOne(creatureSet.appearance.face_shape || []) + ", " +
      pickOne(creatureSet.appearance.face_aesthetics || []) + " face" +
      connectionString + pickOne(creatureSet.appearance.build || []) + ". " +
      npcValues.firstname + " " + pickOne(creatureSet.hooks || []) + ".";

    npcValues.description = replacePlaceholders(npcValues.description, gender === "male", data);

    if (descType === "generic") {
      npcValues.description = npcValues.firstname + npcValues.description;
    } else if (descType === "tavern") {
      npcValues.tavernKeepDescription = npcValues.description;
    }

    return npcValues;
  }

  function TavernGenerator(container, data) {
    this.container = container;
    this.data = data;
    this.currentTavern = null;

    this.els = {
      wealth: container.querySelector('[data-tg="wealth"]'),
      menu: container.querySelector('[data-tg="menu"]'),
      rumors: container.querySelector('[data-tg="rumors"]'),
      pricing: container.querySelector('[data-tg="pricing"]'),
      generateBtn: container.querySelector('[data-tg="generate"]'),
      rerollBtn: container.querySelector('[data-tg="reroll"]'),
      name: container.querySelector('[data-tg="name"]'),
      description: container.querySelector('[data-tg="description"]'),
      table: container.querySelector('[data-tg="table"]'),
      rumorsOut: container.querySelector('[data-tg="rumors-out"]')
    };

    var self = this;
    this.els.generateBtn.addEventListener("click", function () {
      self.generateTavern();
    });

    this.els.rerollBtn.addEventListener("click", function () {
      if (!self.currentTavern) return;
      self.generateTavernRumorsAndMenu(self.currentTavern);
      self.displayTavern();
    });
  }

  TavernGenerator.prototype.generateTavernName = function () {
    var data = this.data;
    var tavernName = pickOne(data.tavern.name.template);
    var ownerGender = Math.random() > 0.5 ? "male" : "female";
    var tavernOwner = generateNPC(data, ownerGender, data.names.anglo, "humanoid", "tavern");

    var ending = "'s";
    if (tavernOwner.firstname && tavernOwner.firstname.substring(tavernOwner.firstname.length - 1) === "s") ending = "'";
    tavernName = tavernName.replace(/_name/g, tavernOwner.firstname + ending);
    tavernName = tavernName.replace(/_common_animal/g, pickOne(data.common_animal));
    tavernName = tavernName.replace(/_adjective/g, pickOne(data.tavern.name.adjective));
    tavernName = tavernName.replace(/_tavern/g, pickOne(data.tavern.name.tavern));
    tavernName = tavernName.replace(/_profession/g, pickOne(data.tavern.name.profession));
    tavernName = tavernName.replace(/_unique/g, pickOne(data.tavern.name.unique));

    return { name: tavernName, owner: tavernOwner };
  };

  TavernGenerator.prototype.generateTavern = function () {
    var data = this.data;
    var tavern = this.generateTavernName();
    var wealth = parseInt(this.els.wealth.value, 10);
    tavern.wealth = wealth;

    var tavernName = tavern.name;
    var tavernOwner = tavern.owner;

    var description = "<strong>" + tavernName + "</strong>" +
      [" is located", " is situated", " can be found", " is placed "][Math.floor(Math.random() * 4)] +
      " " + pickOne(data.tavern.locations) + ". ";

    description += "The interior is " + pickOne(data.shops.interior.description[wealth]) +
      " with a " + pickOne(data.tavern.flooring[wealth]) + " floor.";
    description += " The bar is " + pickOne(data.tavern.barstyle) + ". " +
      ["Round", "Square"][Math.floor(Math.random() * 2)] + " tables are " + pickOne(data.tavern.table_setup) + ".";

    description += " " + pickOne(data.tavern.that_little_extra[wealth]) + ".";
    description = description.replace(/_material/g, pickOne(data.material[wealth]));

    description = replacePlaceholders(description, Math.random() > 0.5, data);

    var ownerName = tavernOwner.lastname;
    if (ownerName) ownerName = " " + ownerName;
    description += "<br><br>The owner, " + tavernOwner.firstname + (ownerName || "") + "," + tavernOwner.tavernKeepDescription;

    tavern.description = description;
    this.generateTavernRumorsAndMenu(tavern);
    this.currentTavern = tavern;
    this.displayTavern();
  };

  TavernGenerator.prototype.generateTavernRumorsAndMenu = function (tavern) {
    var data = this.data;
    var wealth = tavern.wealth;
    var menuType = this.els.menu.value;
    var rumourCount = this.els.rumors.value;
    var price = parseFloat(this.els.pricing.value);

    tavern.menuType = menuType;
    tavern.rumourCount = rumourCount;
    tavern.price = price;

    var menuArray = data.tavern.menu[menuType];
    var arr = [pickX(menuArray[wealth][0], d(2)), pickX(menuArray[wealth][1], d(2))];
    var drinks = pickX(data.tavern.drinks[menuType][wealth], d(4) + wealth);

    var finalMenuArray = [];
    var pricesArray = [];
    var priceBase;
    var coinString;

    var tavernEconomyArray = [
      [d(4), "cp"],
      [d(3), "sp"],
      [d(10), "sp"],
      [d(6), "gp"]
    ];

    priceBase = tavernEconomyArray[wealth][0];
    priceBase *= price;
    coinString = tavernEconomyArray[wealth][1];

    for (var i = 1; i < 3; i++) {
      for (var j = 0; j < arr[i - 1].length; j++) {
        var dish = arr[i - 1][j];
        var vegetables = pickX(data.vegetables, 2);
        var exoticVegetables = pickX(data.exotic_vegetables, 2);

        dish = dish.replace(/_2vegetables/g, vegetables[0] + " and " + vegetables[1]);
        dish = dish.replace(/_2exotic_vegetables/g, exoticVegetables[0] + " and " + exoticVegetables[1]);
        dish = dish.replace(/_exotic_vegetables/g, pickOne(data.exotic_vegetables));
        dish = dish.replace(/_vegetables/g, pickOne(data.vegetables));
        dish = dish.replace(/_meat/g, pickOne(data.meat));
        dish = dish.replace(/_exoticmeat/g, pickOne(data.exotic_meat));
        dish = dish.replace(/_fish/g, pickOne(data.fish));
        dish = dish.replace(/_dessert/g, pickOne(data.tavern.desserts));
        dish = toProperCase(dish);

        finalMenuArray.push(dish);
        var finalPrice = i * priceBase;
        pricesArray.push(convertAmountToHighestCurrency(finalPrice, coinString, data.currencies));
      }
    }

    for (var k = 0; k < drinks.length; k++) {
      var drink = drinks[k];
      drink = drink.replace(/_brewer/g, pickOne(data.tavern.brewers));
      pricesArray.push(convertAmountToHighestCurrency(priceBase, coinString, data.currencies));
      finalMenuArray.push(drink);
    }

    tavern.menu = { item: finalMenuArray, price: pricesArray };
    tavern.rumors = this.generateRumors(d(3) * parseInt(rumourCount, 10), data);
  };

  TavernGenerator.prototype.generateRumors = function (rumorAmount, data) {
    var rumorArray = pickX(data.rumors, rumorAmount);
    if (rumorAmount > data.rumors.length) rumorAmount = data.rumors.length;

    for (var i = 0; i < rumorArray.length; i++) {
      var rumor = rumorArray[i];
      rumor = rumor.replace(/_manwoman/g, pickOne(["man", "woman"]));
      rumor = rumor.replace(/_tavernname/g, this.generateTavernName().name);
      rumor = rumor.replace(/_noble/g, pickOne(data.noble));
      rumor = rumor.replace(/_forest/g, pickOne(data.forests));
      rumor = replaceAllToken(rumor, "_creatures", data.creatures);
      rumor = replaceAllToken(rumor, "_monster", data.monsters);
      rumor = replaceAllToken(rumor, "_mountain", data.mountains);
      rumor = replaceAllToken(rumor, "_structure", data.structures);

      var allProfessions = data.generated_creatures.humanoid.professions.common
        .concat(data.generated_creatures.humanoid.professions.uncommon)
        .concat(data.generated_creatures.humanoid.professions.rare);

      rumor = rumor.replace(/_profession/g, pickOne(allProfessions).toLowerCase());
      rumor = replaceAllToken(rumor, "_forest", data.forests);
      rumor = replaceAllToken(rumor, "_name", data.names.anglo.male);
      rumor = replaceAllToken(rumor, "_femalename", data.names.anglo.female);
      rumor = replaceAllToken(rumor, "_lastname", data.names.anglo.lastnames);
      rumor = replaceAllToken(rumor, "_locale", data.locales);
      rumor = capitalizeAndDot(rumor);

      var monger = generateNPC(data, Math.random() > 0.5 ? "male" : "female", data.names.anglo, "humanoid", "generic");
      rumorArray[i] = { rumor: rumor, monger: monger };
    }

    return rumorArray;
  };

  TavernGenerator.prototype.displayTavern = function () {
    var tavern = this.currentTavern;
    if (!tavern) return;

    this.els.rerollBtn.classList.remove("tg-hidden");
    this.els.name.textContent = tavern.name || "";
    this.els.description.innerHTML = tavern.description || "";

    this.displayMenu();
    this.displayRumors();
  };

  TavernGenerator.prototype.displayMenu = function () {
    var tableWrap = this.els.table;
    while (tableWrap.firstChild) tableWrap.removeChild(tableWrap.firstChild);

    if (!this.currentTavern || !this.currentTavern.menu) return;
    var items = this.currentTavern.menu.item;
    var prices = this.currentTavern.menu.price;

    var table = document.createElement("table");
    var thead = document.createElement("thead");
    var trh = document.createElement("tr");
    var th1 = document.createElement("th");
    var th2 = document.createElement("th");
    th1.textContent = "Menu Item";
    th2.textContent = "Price";
    trh.appendChild(th1);
    trh.appendChild(th2);
    thead.appendChild(trh);
    table.appendChild(thead);

    var tbody = document.createElement("tbody");
    for (var i = 0; i < items.length; i++) {
      var tr = document.createElement("tr");
      var td1 = document.createElement("td");
      var td2 = document.createElement("td");
      td1.textContent = items[i];
      td2.textContent = prices[i];
      tr.appendChild(td1);
      tr.appendChild(td2);
      tbody.appendChild(tr);
    }
    table.appendChild(tbody);
    tableWrap.appendChild(table);
  };

  TavernGenerator.prototype.displayRumors = function () {
    var rumorsWrap = this.els.rumorsOut;
    while (rumorsWrap.firstChild) rumorsWrap.removeChild(rumorsWrap.firstChild);

    if (!this.currentTavern || !this.currentTavern.rumors) return;
    var rumorArray = this.currentTavern.rumors;
    if (!rumorArray.length) return;

    var header = document.createElement("h3");
    header.textContent = "Rumors";
    rumorsWrap.appendChild(header);

    for (var i = 0; i < rumorArray.length; i++) {
      var rumor = rumorArray[i];
      var block = document.createElement("div");
      block.className = "tg-rumor";

      var title = document.createElement("p");
      title.className = "tg-rumor-title";

      var traveling = Math.random() > 0.8 ? "traveling" : "local";
      var age = rumor.monger.age ? " (" + rumor.monger.age + ")" : "";
      title.innerHTML = "<strong>" + rumor.monger.firstname + " " + (rumor.monger.lastname || "") +
        ", a " + traveling + " " + rumor.monger.profession.toLowerCase() + age + "</strong>";

      var text = document.createElement("p");
      text.className = "tg-rumor-text";
      text.textContent = '"' + rumor.rumor + '"';

      var desc = document.createElement("p");
      desc.className = "tg-rumor-desc";
      desc.innerHTML = rumor.monger.description;

      block.appendChild(title);
      block.appendChild(text);
      block.appendChild(desc);
      rumorsWrap.appendChild(block);
    }
  };

  function initTavernGenerators() {
    var sections = document.querySelectorAll("[data-tg-root]");
    if (!sections.length) return;

    sections.forEach(function (section) {
      var dataTag = section.querySelector("script[data-tg-json]");
      if (!dataTag) return;

      try {
        var data = JSON.parse(dataTag.textContent || "{}");
        if (!data || !data.tavern) return;
        new TavernGenerator(section, data);
      } catch (e) {
        return;
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initTavernGenerators);
  } else {
    initTavernGenerators();
  }
})();
